import { render, staticRenderFns } from "./VideoLecture.vue?vue&type=template&id=d69b7da6&scoped=true"
import script from "./VideoLecture.vue?vue&type=script&lang=js"
export * from "./VideoLecture.vue?vue&type=script&lang=js"
import style0 from "./VideoLecture.vue?vue&type=style&index=0&id=d69b7da6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d69b7da6",
  null
  
)

export default component.exports